import {Box, Typography} from "@mui/material";
import React from "react";
import { AppToggleButton } from "@components";
import { AGGREGATION_PRICE } from "../@constants";
import { europcarPricingEnvAgregationPrice } from "../@signals";
import { isLoadingCommonFilters } from "@signals";

const TABS = [
    { label: 'Min. Price', value: AGGREGATION_PRICE.MIN },
    { label: 'Avg. Price', value: AGGREGATION_PRICE.AVG },
    { label: 'Max. Price', value: AGGREGATION_PRICE.MAX },
]

export default function PricingEnvironmentTableTitle() {


    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="title">Pricing Environment</Typography>
        <Box sx={{ m: 1 }}>
            <AppToggleButton
                tabs={TABS}
                value={europcarPricingEnvAgregationPrice.value}
                onChange={(_, newValue) => {
                    europcarPricingEnvAgregationPrice.value = newValue
                    isLoadingCommonFilters.value = true
                }}
                buttonProps={{
                    sx: { px: 2.5, py: 1 }
                }}
            />
        </Box>
    </Box>
}